import OrganizatonUsersTable from '@/components/super-admin/organization/users_table/OrganizationUsersTable';
import OrganizationSummary from '../../../components/super-admin/organization/OrganizationSummary';
import OrganizatonTelletsTable from '@/components/super-admin/organization/tellets_table/OrganizationTelletsTable';
import OrganizatonWorkspacesTable from '@/components/super-admin/organization/workspaces_table/OrganizationWorkspacesTable';

function SuperAdminSingleOrganization() {
  return (
    <main className="flex flex-col w-full h-full">
      <h1 className="mb-8 font-bold text-primary">Organization name</h1>
      <div className="flex flex-col w-full gap-5">
        <OrganizationSummary />
      </div>
      <h1 className="mt-12 font-bold">Users</h1>
      <div className="w-full">
        <OrganizatonUsersTable />
      </div>
      <h1 className="mt-8 font-bold">Tellets</h1>
      <div className="w-full">
        <OrganizatonTelletsTable />
      </div>
      <h1 className="mt-8 font-bold">Workspaces</h1>
      <div className="w-full">
        <OrganizatonWorkspacesTable />
      </div>
    </main>
  );
}

export default SuperAdminSingleOrganization;
